import { render, staticRenderFns } from "./Type2Box.vue?vue&type=template&id=85a10750&scoped=true"
import script from "./Type2Box.vue?vue&type=script&lang=js"
export * from "./Type2Box.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a10750",
  null
  
)

export default component.exports